import React, { useState } from 'react';
import OTPInput from 'react-otp-input';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { coachPaths } from '../../../routes/coach';
import toast from 'react-hot-toast';
import { shareOtp } from '../../../redux/features/coach/actions/authAction';
import AuthLayout from '../../../layouts/AuthLayout';
import Loader from '../../loader';

const OtpVerification = ({ onClose, backToLogin, dbCode, email, nextStep, isLoad, setIsLoad, otpScreen }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [otp, setOtp] = useState("");

    const handleSendOtp = (e) => {
        e.preventDefault();
        if (otp.length === 4) {
            setIsLoad(true);
            const callback = (response) => {
                setIsLoad(false);
                if (response.success) {
                    nextStep();
                } else {
                    otpScreen()
                }
            };
            dispatch(shareOtp({ payload: { email, otp }, callback }));
        } else {
            toast.error("Please enter the full OTP");
        }
    };

    if (isLoad) {
        return <Loader />
    }
    return (
        <div
            className="modal d-block ct_large_modal_width ct_congratulation_modal_fade"
            tabIndex="-1"
        >
            <div class="modal-dialog modal-dialog-centered ct_modal-dialog">
                <div class="modal-content">
                    <div class="modal-header border-0 p-0 pb-2">
                        <button
                            type="button"
                            class="btn-close ct_close_position_right12"
                            onClick={onClose}
                        ></button>
                    </div>
                    <div class="modal-body pe-0">
                        <section class="ct_signup_main py-3">
                            <div class="container-fluid">
                                <div class="row align-items-center">
                                    <div class="col-xxl-4 col-xl-4 col-lg-4 mb-4 mb-lg-0 d-none d-lg-block">
                                        <div class="ct_signup_left_img">
                                            <img src="/assets/img/girl_laptop_1.png" alt="" />
                                        </div>
                                    </div>
                                    <div class="col-xxl-8 col-xl-7 col-lg-7 mb-4 mb-lg-0 mx-auto pe-0">
                                        <div class="ct_signup_right_content px-3 ct_custom_scroll pe-5">
                                            <div class="ct_signup_logo ct_mb_30">
                                                <img src="/assets/img/Nuvio_logo.png" alt="" />
                                            </div>
                                            <div class="mt-0 text-center">
                                                <h2 class="ct_fs_32  mb-2 ct_darkblue_text">Password Reset</h2>
                                                <p
                                                    class="mb-0 ct_darkblue_text mx-auto"
                                                    style={{ maxWidth: "434px" }}
                                                >
                                                    Code sent to {email}. Check your inbox and enter it
                                                    below to reset your password.
                                                </p>
                                            </div>
                                            <form class="mt-4">
                                                <div class="row">
                                                    <div class="col-md-12">
                                                        <div class="ct_otp_input">
                                                            <OTPInput
                                                                class="form-control ct_input"
                                                                inputType="number"
                                                                value={otp}
                                                                onChange={setOtp}
                                                                numInputs={4}
                                                                renderSeparator={<span>-</span>}
                                                                renderInput={(props) => <input {...props} />}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="text-center mt-4">
                                                    <a
                                                        onClick={(e) => handleSendOtp(e)}
                                                        class="ct_yellow_btn w-75 mx-auto"
                                                    >
                                                        Continue{" "}
                                                    </a>
                                                </div>
                                                {/* <p class="mb-0 text-center mt-3">
                                                    Didn’t receive the email?{" "}
                                                    <a class="ct_orange_text">
                                                        {" "}
                                                        Click to resend
                                                    </a>
                                                </p> */}
                                            </form>
                                            <div class="ct_back_login_text text-center mt-3">
                                                <a
                                                    onClick={backToLogin}
                                                    class="mb-0 ct_darkblue_text"
                                                >
                                                    <i class="fa-solid fa-arrow-left"></i> Back to Log In
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default OtpVerification;